import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const CheckmarkOutlined = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function CheckmarkOutlined({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <path d="m8.5 19.31-6.21-6.2 1.42-1.42 4.79 4.8 11.79-11.8 1.42 1.42L8.5 19.31Z" fill="currentColor" />
      </svg>;
}) as ForwardedIconComponent);
export default CheckmarkOutlined;